import { Link } from 'react-router-dom';
import DashboardTabs from './DashboardTabs';
import UserMenu from './UserMenu';
export default function DashboardNavbar() {
    return (
        <nav className="fixed top-0 left-0 right-0 h-16 bg-[#0B0B0F]/80 backdrop-blur-xl border-b border-white/[0.08] z-40">
            <div className="max-w-7xl mx-auto px-6 h-full flex items-center justify-between relative">
                {/* Left: Logo */}
                <div className="flex items-center gap-12 h-full">
                    <Link to="/dashboard/overview" className="flex items-center gap-2 group">
                        <img src="/logo.png" alt="PitchMe.AI" className="w-8 h-8 rounded-lg shadow-lg group-hover:shadow-white/20 transition-all" />
                        <span className="font-bold text-white tracking-tight">PitchMe<span className="text-zinc-500">.AI</span></span>
                    </Link>
                </div>

                {/* Center: Tabs (Absolute Centered) */}
                <div className="hidden md:flex h-full absolute left-1/2 -translate-x-1/2">
                    <DashboardTabs />
                </div>

                {/* Right: Actions */}
                <div className="flex items-center gap-4">
                    <UserMenu />
                </div>
            </div>
        </nav>
    );
}
